// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

/* insurance info */
.Insurance_insurance_list__3OjyK{width: 100%;}
.Insurance_insurance_list__3OjyK .Insurance_tab__cLqHE{margin-bottom: 15px;}
.Insurance_insurance_list__3OjyK .Insurance_tab__cLqHE ul{display: flex;gap: 15px;}
.Insurance_insurance_list__3OjyK .Insurance_tab__cLqHE ul li div{
    display: inline-flex;
    padding: 5px 14px;
    align-items: center;
    border-radius: 21px;
    border: 1px solid #51D7DF;
    background: #FFF;
    color: #51D7DF;
    font-size: 18px;
    font-weight: 700;
}

.Insurance_insurance_list__3OjyK .Insurance_tab__cLqHE ul li.Insurance_on__MACY2 div{
    background:#51D7DF;
    color: #fff;
}

.Insurance_insurance_info__BmKFI{
    width: inherit;
    height: 701px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    overflow-y: scroll;
}

.Insurance_insurance_info__BmKFI .Insurance_title__u-QxP {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin-bottom: 10px;
}

.Insurance_insurance_info__BmKFI .Insurance_describe__enQWd {
    font-size: 16px;
    color: #4E4E4E;
    margin-bottom: 10px;
}

.Insurance_insurance_info__BmKFI .Insurance_banner__BgrPY {
    display: flex;
    width: 100%;
    justify-content: center; 
    align-items: center;
    margin-bottom: 10px;
}

.Insurance_insurance_info__BmKFI .Insurance_detail_title__ecoYH {
    font-size: 16px;
    color: #4E4E4E;
    font-weight: 700;
    margin-bottom: 10px;
}

.Insurance_insurance_info__BmKFI .Insurance_details__C9tSK {
    font-size: 16px;
    color: #4E4E4E;
    margin-bottom: 10px;
}

/* CustomerList */
.Insurance_customer_title__KrZEV {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
}

.Insurance_customer_list__7l7gZ{
    width: 800px;
    height: 700px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    overflow-y: scroll;
}

.Insurance_customer_info__a8NNx{
    width:702px;
    border-radius: 10px;
    height: 40px;
    background: #DADCE0;
    box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);
    display: flex;
    font-size: 16px;
    align-items: center;
    padding: 0 30px;
    gap:30px;
    margin-bottom: 10px;
}

.Insurance_customer_info__a8NNx:last-child { margin-bottom: 0; }
.Insurance_customer_info__a8NNx .Insurance_tit__Ak\\+HR{color: #fff;margin-right: 5px;}`, "",{"version":3,"sources":["webpack://./src/pages/Insurance/index.module.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,mBAAmB;AACnB,iCAAgB,WAAW,CAAC;AAC5B,uDAAqB,mBAAmB,CAAC;AACzC,0DAAkE,aAAa,CAAC,SAAS,CAAC;AAC1F;IAGI,oBAAoB;IACpB,iBAAiB;IAGT,mBAAmB;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,sDAAsD;IAC9D,aAAa;IAEL,sBAAsB;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,sDAAsD;IAC9D,aAAa;IAEL,sBAAsB;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IAEX,sDAAsD;IAG9D,aAAa;IACb,eAAe;IAGP,mBAAmB;IAC3B,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA,6CAA4B,gBAAgB,EAAE;AAC9C,uDAAoB,WAAW,CAAC,iBAAiB,CAAC","sourcesContent":["@charset \"utf-8\";\n\n/* insurance info */\n.insurance_list{width: 100%;}\n.insurance_list .tab{margin-bottom: 15px;}\n.insurance_list .tab ul{display: -webkit-box;display: -ms-flexbox;display: flex;gap: 15px;}\n.insurance_list .tab ul li div{\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    padding: 5px 14px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 21px;\n    border: 1px solid #51D7DF;\n    background: #FFF;\n    color: #51D7DF;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.insurance_list .tab ul li.on div{\n    background:#51D7DF;\n    color: #fff;\n}\n\n.insurance_info{\n    width: inherit;\n    height: 701px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    padding: 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    position: relative;\n    overflow-y: scroll;\n}\n\n.insurance_info .title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.insurance_info .describe {\n    font-size: 16px;\n    color: #4E4E4E;\n    margin-bottom: 10px;\n}\n\n.insurance_info .banner {\n    display: flex;\n    width: 100%;\n    justify-content: center; \n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.insurance_info .detail_title {\n    font-size: 16px;\n    color: #4E4E4E;\n    font-weight: 700;\n    margin-bottom: 10px;\n}\n\n.insurance_info .details {\n    font-size: 16px;\n    color: #4E4E4E;\n    margin-bottom: 10px;\n}\n\n/* CustomerList */\n.customer_title {\n    font-size: 24px;\n    font-weight: 700;\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.customer_list{\n    width: 800px;\n    height: 700px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    padding: 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    position: relative;\n    overflow-y: scroll;\n}\n\n.customer_info{\n    width:702px;\n    border-radius: 10px;\n    height: 40px;\n    background: #DADCE0;\n    -webkit-box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n            box-shadow: 0px 4px 15px 0px rgba(232, 232, 232, 0.64);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 16px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    padding: 0 30px;\n    gap:30px;\n    margin-bottom: 10px;\n}\n\n.customer_info:last-child { margin-bottom: 0; }\n.customer_info .tit{color: #fff;margin-right: 5px;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"insurance_list": `Insurance_insurance_list__3OjyK`,
	"tab": `Insurance_tab__cLqHE`,
	"on": `Insurance_on__MACY2`,
	"insurance_info": `Insurance_insurance_info__BmKFI`,
	"title": `Insurance_title__u-QxP`,
	"describe": `Insurance_describe__enQWd`,
	"banner": `Insurance_banner__BgrPY`,
	"detail_title": `Insurance_detail_title__ecoYH`,
	"details": `Insurance_details__C9tSK`,
	"customer_title": `Insurance_customer_title__KrZEV`,
	"customer_list": `Insurance_customer_list__7l7gZ`,
	"customer_info": `Insurance_customer_info__a8NNx`,
	"tit": `Insurance_tit__Ak+HR`
};
export default ___CSS_LOADER_EXPORT___;
